"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-italic-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M17.94 14.08h1.54l-1.96 9.72H16l1.94-9.72zm1.3-2.02c-.267 0-.497-.077-.69-.23-.193-.153-.29-.377-.29-.67 0-.333.117-.61.35-.83.233-.22.503-.33.81-.33.267 0 .497.08.69.24.193.16.29.387.29.68 0 .333-.117.607-.35.82-.233.213-.503.32-.81.32z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-italic-on.js
// module id = 1842
// module chunks = 0